define('customPlugins/atnKendoDateTimePicker',[
        'knockout','kendo-knockout',
    ],
    function(ko) {
        'use strict';

        ko.bindingHandlers.atnKendoDateTimePicker = {
            init: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
                var options = valueAccessor();
                options.format = options.format || 'MMM dd yyyy hh:mm tt';
                var valueAccessorFn = function() {
                    return options;
                };

                ko.bindingHandlers.kendoDateTimePicker.init(element, valueAccessorFn, allBindings, viewModel, bindingContext);
            },
            update: ko.bindingHandlers.kendoDateTimePicker.update
        };
    });

